import { Images as LightThemeImages } from './Modes/Light/Images';

export const Images = LightThemeImages;
